import { createAction } from '@ngrx/store';
import { PaginationFilterState } from '../../core/models/entities';

export const setPaginationFilter = createAction(
    '[PaginationFilter] Set Pagination Filter',
    (context: string, paginationFilter: PaginationFilterState) => ({ context, paginationFilter })
);

export const clearPaginationFilter = createAction(
    '[PaginationFilter] Clear Pagination Filter',
    (context: string | null) => ({ context })
);
